import { render, staticRenderFns } from "./GifWall.vue?vue&type=template&id=6bbb46a4&scoped=true&"
import script from "./GifWall.vue?vue&type=script&lang=js&"
export * from "./GifWall.vue?vue&type=script&lang=js&"
import style0 from "./GifWall.vue?vue&type=style&index=0&id=6bbb46a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbb46a4",
  null
  
)

export default component.exports